import BlueskyIcon from '~/components/Icons/BlueskyIcon';
import DiscordIcon from '~/components/Icons/DiscordIcon';
import FacebookIcon from '~/components/Icons/FacebookIcon';
import InstagramIcon from '~/components/Icons/InstagramIcon';
import LinkedinIcon from '~/components/Icons/LinkedInIcon';
import ThreadsIcon from '~/components/Icons/ThreadsIcon';
import TiktokIcon from '~/components/Icons/TiktokIcon';
import TwitterIcon from '~/components/Icons/TwitterIcon';
import YoutubeIcon from '~/components/Icons/YoutubeIcon';
import type { Publication } from '~/interfaces/publication';
import makeExternalUrl from '~/utils/makeExternalUrl';

import Section from './Section';

interface Props {
  publication: Publication;
  textColor: string;
  isNewWebBuilder?: boolean;
}

const SocialWidgetSection = ({ publication, textColor, isNewWebBuilder = false }: Props) => {
  const tiktokUrl = publication.tiktok_url;
  const twitterUrl = publication.twitter_url;
  const youtubeUrl = publication.youtube_url;
  const facebookUrl = publication.facebook_url;
  const instagramUrl = publication.instagram_url;
  const linkedInUrl = publication.linkedin_url;
  const threadsUrl = publication.threads_url;
  const discordUrl = publication.discord_url;
  const blueskyUrl = publication.bluesky_url;

  return (
    <Section text="Social" isNewWebBuilder={isNewWebBuilder}>
      <div
        className="flex space-x-2 transition-all"
        style={{
          color: textColor,
        }}
      >
        {twitterUrl && (
          <a target="_blank" rel="noreferrer" href={makeExternalUrl(twitterUrl)} aria-label="X">
            <TwitterIcon className="h-4 w-4 fill-current opacity-70 hover:opacity-100" />
          </a>
        )}
        {linkedInUrl && (
          <a target="_blank" rel="noreferrer" href={makeExternalUrl(linkedInUrl)} aria-label="LinkedIn">
            <LinkedinIcon className="h-4 w-4 fill-current opacity-70 hover:opacity-100" />
          </a>
        )}
        {youtubeUrl && (
          <a target="_blank" rel="noreferrer" href={makeExternalUrl(youtubeUrl)} aria-label="Youtube">
            <YoutubeIcon className="h-4 w-4 fill-current opacity-70 hover:opacity-100" />
          </a>
        )}
        {tiktokUrl && (
          <a target="_blank" rel="noreferrer" href={makeExternalUrl(tiktokUrl)} aria-label="Tiktok">
            <TiktokIcon className="h-4 w-4 fill-current opacity-40 hover:opacity-100" />
          </a>
        )}
        {facebookUrl && (
          <a target="_blank" rel="noreferrer" href={makeExternalUrl(facebookUrl)} aria-label="Facebook">
            <FacebookIcon className="h-4 w-4 fill-current opacity-70 hover:opacity-100" />
          </a>
        )}
        {instagramUrl && (
          <a target="_blank" rel="noreferrer" href={makeExternalUrl(instagramUrl)} aria-label="Instagram">
            <InstagramIcon className="h-4 w-4 fill-current opacity-70 hover:opacity-100" />
          </a>
        )}
        {threadsUrl && (
          <a target="_blank" rel="noreferrer" href={makeExternalUrl(threadsUrl)} aria-label="Threads">
            <ThreadsIcon className="h-4 w-4 fill-current opacity-70 hover:opacity-100" />
          </a>
        )}
        {discordUrl && (
          <a target="_blank" rel="noreferrer" href={makeExternalUrl(discordUrl)} aria-label="Discord">
            <DiscordIcon className="h-4 w-4 fill-current opacity-70 hover:opacity-100" />
          </a>
        )}
        {blueskyUrl && (
          <a target="_blank" rel="noreferrer" href={makeExternalUrl(blueskyUrl)} aria-label="Bluesky">
            <BlueskyIcon className="h-4 w-4 fill-current opacity-70 hover:opacity-100" />
          </a>
        )}
      </div>
    </Section>
  );
};

export default SocialWidgetSection;
